import { Component, OnInit, ViewChild } from '@angular/core';

import { ClienteService } from '../../services/cliente.service';
import { ClienteViewModel } from '../../models/viewmodels/clienteViewModel';

import { DoubleBounceComponent } from '../../shared/spinners/double-bounce/double-bounce.component'
import { CustomAlertComponent } from '../../shared/custom-alert/custom-alert.component';

import { Router } from '@angular/router'

@Component({
  selector: 'app-editar-cliente',
  templateUrl: './editar-cliente.component.html',
  styleUrls: ['./editar-cliente.component.scss']
})
export class EditarClienteComponent implements OnInit {

  cliente: ClienteViewModel;
  alert: any = {
    tipo: "success",
    titulo: "",
    mensaje: "",
    visible: false
  }

  errores = new Array();

  @ViewChild(DoubleBounceComponent)
  spinner: DoubleBounceComponent;

  @ViewChild(CustomAlertComponent)
  private alertComponent: CustomAlertComponent;

  constructor(private clienteService: ClienteService, private router: Router) {
    this.cliente = this.clienteService.getCliente();
    if (!this.cliente) {
      this.router.navigate(['dashboard/clientes'])
    }    
  }

  ngOnInit() {
    this.spinner.isRunning = false;
  }

  onSubmit() {
    this.spinner.isRunning = true;
    this.alert.visible = false;
    this.clienteService.guardar(this.cliente)
      .map(result => {
        this.alert.visible = true;
        this.alert.titulo = "Actualizar cliente";
        if (result.status == 204) {
          this.alert.tipo = "success"
          this.alert.mensaje = "Los datos se han actualizado correctamente"
        } else {
          this.alert.tipo = "danger"
          this.alert.mensaje = "Los datos no se han podido actualizar. Por favor vuelva a intentarlo."
        }        
        this.alertComponent.setType(this.alert.tipo);
        this.spinner.isRunning = false;
      })
      .subscribe(data => {

      }, error => {
        var json = error.json();        
        this.spinner.isRunning = false;
        this.alert.visible = true;
        this.alert.titulo = "Actualizar cliente";
        this.alert.mensaje = "Los datos se han actualizado correctamente"
        this.alert.tipo = "danger"
        this.alertComponent.setType(this.alert.tipo);
        this.alert.mensaje = "Los datos no se han podido actualizar. Por favor vuelva a intentarlo."        
        if (json.modelState) {
          for (var key in json.modelState) {
            if (json.modelState[key].length == 1) {
              this.errores.push(json.modelState[key]);
            } else {
              for (var i = 0; i < json.modelState[key].length; i++) {
                this.errores.push(json.modelState[key][i]);
              }
            }
          }
        }
      });
  }

  volver(){
    this.router.navigate(['dashboard/clientes']);
  }
}



// WEBPACK FOOTER //
// C:/Source/eSoftCereal.API/eSoftCereal.UI/src/app/clientes/editar/editar-cliente.component.ts